import { getDictionaryFromWms } from '@/api/base';

export default {
  data() {
    return {
      dictionary: [],
      temperType: [],
      storeType: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.dictionary = await getDictionaryFromWms();
      this.temperType = this.getDictionary('ZONE_TEMPERATURE_LAYER_CODE');
      this.storeType = this.getDictionary('WAREHOUSE_ATTR_CODE');
    },
    getDictionary(key) {
      const { dictionary } = this;
      const result = dictionary.find((item) => item.dictionaryCode === key);
      return result.dictionaryValues;
    },
  },
};
